import React from 'react';
import ReactSVG from 'react-svg';
import { PictureAsPdf, Visibility } from '@material-ui/icons';
import { DownloadIcon } from '~/assets/svgIcons';
import {
  PdfPreviewCard,
  PdfPreviewIcon,
  PdfPreviewInfo,
  PdfPreviewName,
  PdfPreviewHint,
  PdfPreviewActions,
} from './styles';

interface PdfPreviewProps {
  name: string;
  size: number;
  onPreview: () => void;
  onDownload: React.MouseEventHandler<any>;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({
  name,
  size,
  onPreview,
  onDownload,
}) => (
  <PdfPreviewCard data-test-id="pdf-preview-card" onClick={onPreview}>
    <PdfPreviewIcon>
      <PictureAsPdf />
    </PdfPreviewIcon>

    <PdfPreviewInfo>
      <PdfPreviewName title={name}>{name}</PdfPreviewName>
      <PdfPreviewHint>
        <Visibility />
        Click to preview
        {size > 0 && ` • ${Math.round(size / 1024)} KB`}
      </PdfPreviewHint>
    </PdfPreviewInfo>

    <PdfPreviewActions>
      <ReactSVG
        src={DownloadIcon}
        className="icon-download"
        onClick={onDownload}
      />
    </PdfPreviewActions>
  </PdfPreviewCard>
);

export default PdfPreview;
